<script setup lang="ts">
  defineProps({
    href: { type: String, required: false, default: '#main' },
  });
</script>
<template>
  <a :href class="btn skip-to-content" >
    <slot>
      {{ $t('SHOP.COMMON.ACTION.SKIP_TO_CONTENT') }}
    </slot>
  </a>
</template>
<style scoped lang="scss">
  .skip-to-content {
    position: absolute;
    top: 0;
    left: 1rem;
    z-index: 1000;
    opacity: 0;
    pointer-events: none;
    transform: translateY(0);
    margin: 1rem 0;
    transition-property: opacity, transform;

    &:focus-visible {
      opacity: 1;
      pointer-events: initial;
      transform: translateY(0rem);
    }
  }
</style>
